import React from 'react';
import Formacao1 from './1';
import Formacao2 from './2';
// import Formacao3 from './3';
// import Formacao4 from './4';
import Formacao5 from './5';
import Formacao6 from './6';
import Formacao7 from './7';

function Formacao() {
  return (
    <>
      <Formacao1 />
      <Formacao2 />
      {/* <Formacao4 /> */}
      {/* <Formacao3 /> */}
      <Formacao5 />
      <Formacao6 />
      {/* <Formacao7 /> */}
    </>
  );
}

export default Formacao;
